/* eslint-disable @typescript-eslint/no-explicit-any */
import * as msal from '@azure/msal-browser'
import { AccountInfo, RedirectRequest } from '@azure/msal-browser'
import { MsalBase } from 'components/azure-provider/msal-base'
import { MsalOptions } from 'components/azure-provider/msal-options'

export class Msal implements MsalBase {
  private msalInstance

  constructor(public options: MsalOptions) {
    const msalConfig: msal.Configuration = {
      auth: {
        clientId: options.clientId,
        authority: options.authority,
        redirectUri: options.redirectUri,
        postLogoutRedirectUri: options.redirectUri,
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: options.storage,
        storeAuthStateInCookie: false,
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
              return
            }
            switch (level) {
              case msal.LogLevel.Error:
                break
              case msal.LogLevel.Info:
                break
              case msal.LogLevel.Verbose:
                break
              case msal.LogLevel.Warning:
                break
            }
          },
        },
      },
    }

    this.msalInstance = new msal.PublicClientApplication(msalConfig)
  }

  getAccountByUserName = (username: string): msal.AccountInfo | null =>
    this.msalInstance.getAccountByUsername(username)

  login = (): Promise<void> | undefined => {
    const request: RedirectRequest = {
      scopes: process.env.REACT_APP_MSAL_LOGIN_REQUEST?.split(',') || [],
    }
    return this.msalInstance?.loginRedirect(request)
  }

  logout = (): Promise<void> => this.msalInstance.logout()

  handleRedirect = (): Promise<msal.AuthenticationResult | null> =>
    this.msalInstance.handleRedirectPromise()

  refreshToken = (account: AccountInfo): Promise<msal.AuthenticationResult> => {
    const request: msal.SilentRequest = {
      account,
      scopes: process.env.REACT_APP_MSAL_REFRESHTOKEN_REQUEST?.split(',') || [],
    }
    return this.msalInstance.acquireTokenSilent(request)
  }
}
